import { useEffect, useState } from "react"
import { getCoinSupporters } from "@/lib/api/coins"
import { SupportersResp } from "@/types/coins"
import { parseEther } from "viem"

/**
 * This hook returns three lists of supporters, one for each tier (set to $1, $5, and $10).
 */
export function useSupporterTiers(coinId: string, coinsPerUSD: number) {
  const [supportersTier1USD, setSupportersTier1USD] = useState<
    SupportersResp | undefined
  >()
  const [supportersTier5USD, setSupportersTier5USD] = useState<
    SupportersResp | undefined
  >()
  const [supportersTier10USD, setSupportersTier10USD] = useState<
    SupportersResp | undefined
  >()

  useEffect(() => {
    async function getSupporterTiers() {
      if (!coinId || !coinsPerUSD) {
        return
      }

      getCoinSupporters({
        coinId,
        minHoldings: parseEther(coinsPerUSD.toString()),
        maxHoldings: parseEther((5 * coinsPerUSD).toString()),
      }).then((resp) => {
        setSupportersTier1USD(resp)
      })

      getCoinSupporters({
        coinId,
        minHoldings: parseEther((5 * coinsPerUSD).toString()),
        maxHoldings: parseEther((10 * coinsPerUSD).toString()),
      }).then((resp) => {
        setSupportersTier5USD(resp)
      })

      getCoinSupporters({
        coinId,
        minHoldings: parseEther((10 * coinsPerUSD).toString()),
      }).then((resp) => {
        setSupportersTier10USD(resp)
      })
    }

    getSupporterTiers()
  }, [coinId, coinsPerUSD])

  return { supportersTier1USD, supportersTier5USD, supportersTier10USD }
}
